const chartDefinitions = [
  { key: "t2m_dmax", title: "بیشینه روزانه دما", yAxis: "دما (°C)" },
  { key: "t2m_dmin", title: "کمینه روزانه دما", yAxis: "دما (°C)" },
  { key: "tp_dsum", title: "بارش روزانه", yAxis: "بارش (mm)" },
  { key: "rh2m_dm", title: "میانگین روزانه رطوبت", yAxis: "رطوبت (%)" },
  { key: "rh2m_dmin", title: "کمینه روزانه رطوبت", yAxis: "رطوبت (%)" },
  { key: "rh2m_dmax", title: "بیشینه روزانه رطوبت", yAxis: "رطوبت (%)" },
  { key: "t2m_dm", title: "میانگین روزانه دما", yAxis: "دما (°C)" },
  { key: "ssrd_dsum", title: "تشعشع روزانه", yAxis: "تشعشع روزانه (J/m2)" },
  { key: "sshn_dsum", title: "ساعت آفتابی", yAxis: "ساعت آفتابی (hour)" },
  { key: "e_dsum", title: "تبخیر و تعرق روزانه", yAxis: "mm" },
  { key: "sde_dsum", title: "ارتفاع برف روزانه", yAxis: "mm" },
  { key: "cu_dacc", title: "نیاز سرمایی", yAxis: "°C" },

  // Hourly
  { key: "t2m", title: "دما", yAxis: "دما (°C)", isHourly: true },
  { key: "tp", title: "بارش", yAxis: "بارش (mm)", isHourly: true },
  { key: "fg10", title: "سرعت باد گاستی", yAxis: "m/s", isHourly: true },
  { key: "skt", title: "دمای سطح خاک", yAxis: "°C", isHourly: true },
  { key: "ws", title: "پدیده جوی", yAxis: "پدیده جوی", isHourly: true },

  // Wind / others
  { key: "ff_10m_dmax", title: "بیشینه سرعت باد" },
  { key: "dd_10m_dmax", title: "جهت باد بیشینه" },
  { key: "ff_10m_dm", title: "میانگین سرعت باد" },
  { key: "d2m_dm", title: "دمای نقطه شبنم" },
  { key: "skt_dmin", title: "کمینه دمای خاک" },
  { key: "ss_dsum", title: "ارتفاع برف روزانه" },
  { key: "mx2t", title: "بیشینه دما" },
  { key: "mn2t", title: "کمینه دما" },
];

export default chartDefinitions;
